import React, {Component} from 'react';
import _ from 'lodash';
import Loading from "../../loading";

class ActorsModal extends Component {
	render() {
		let {conclusion} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione los actores estratégicos que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.actors.isFetching ? <Loading/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{this.props.actors.actors.map((actor, k) => {
										let shouldCheck = _.findKey(this.props.selectedActors, {id: _.toInteger(actor.id)}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`actor-${actor.id}`} className="checkbox"
												       disabled={conclusion}>
													<input id={`actor-${actor.id}`} ref={`g-actor-${actor.id}`}
													       value={actor.id} type="checkbox" checked={shouldCheck}
													       className="checkbox"
													       onChange={() => this._saveActor(actor.id)}
													       disabled={conclusion}/>
													{actor.name}
												</label>
											</div>
										);
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveActor(actor) {
		if (this.refs[`g-actor-${actor}`].checked) {
			this.props.add(`projects.edit.actors`, _.find(this.props.actors.actors, {id: actor}));
		} else {
			let actorKey = _.findKey(this.props.selectedActors, {id: actor});
			this.props.remove(`projects.edit.actors`, actorKey);
		}
	}
}

/*class ActorsModal2 extends Component {
	render() {
		let {conclusion} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background"/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione los actores estratégicos que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.actors.isFetching ? <Loading/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{this.props.actors.actors.map((actor, k) => {
										let shouldCheck = _.findKey(this.props.selectedActors, {id: _.toInteger(actor.id)}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`actor-${actor.id}`} className="checkbox"
												       disabled={conclusion}>
													<input id={`actor-${actor.id}`} ref={`g-actor-${actor.id}`}
													       value={actor.id} type="checkbox" checked={shouldCheck}
													       className="checkbox"
													       onChange={() => this._saveActor(actor.id)}
													       disabled={conclusion}/>
													{actor.name}
												</label>
											</div>
										);
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveActor(actor) {
		if (this.refs[`g-actor-${actor}`].checked) {
			this.props.add(`projects.goals[${this.props.selectedGoal}].actors`, _.find(this.props.actors.actors, {id: actor}));
		} else {
			let actorKey = _.findKey(this.props.selectedActors, {id: actor});
			this.props.remove(`projects.goals[${this.props.selectedGoal}].actors`, actorKey);
		}
	}
}*/

export default ActorsModal;


// WEBPACK FOOTER //
// ./src/elements/projects/widgets/actors-modal.jsx